import { render, staticRenderFns } from "./KeldiKetdi.vue?vue&type=template&id=7fa3e90b&scoped=true"
import script from "./KeldiKetdi.vue?vue&type=script&lang=js"
export * from "./KeldiKetdi.vue?vue&type=script&lang=js"
import style0 from "./KeldiKetdi.vue?vue&type=style&index=0&id=7fa3e90b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3e90b",
  null
  
)

export default component.exports